module.exports = __webpack_public_path__ + "media/images/zoomify_size-ccaf302a38e12b164274cc3ab3a47dbb.png";